import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useRole } from 'hooks/useRole';

import { sidebarSelector } from 'store/slices/sidebar';

import Copyright from 'components/Copyright/Copyright';
import Logo from 'components/Logo/Logo';
import PageAccessController from 'components/PageAccessController/PageAccessController';
import ContentLinks from 'components/Sidebar/ContentLinks/ContentLinks';
import Item from 'components/Sidebar/Item/Item';

import { items } from 'components/config/sidebar';

import styles from 'components/Sidebar/Sidebar.module.scss';

const Sidebar = () => {
  const isVisibleSidebar = useSelector(sidebarSelector.getVisible);

  const role = useRole();

  const orderedItems = useMemo(
    () => [...items].sort((a, b) => a.getOrder(role) - b.getOrder(role)),
    [role],
  );

  const pages = useMemo(
    () =>
      orderedItems.map(({ feature, isEnabled, ...item }) => (
        <PageAccessController
          key={item.title}
          Element={() => <Item {...item} />}
          feature={feature}
          isEnabled={isEnabled}
        />
      )),
    [orderedItems],
  );

  return (
    <div className={styles.wrapper} data-testid="sidebar-root">
      <div>
        <Logo />
        <div>{pages}</div>
      </div>
      {isVisibleSidebar && (
        <div className={styles.footer} data-testid="sidebar-footer">
          <ContentLinks />
          <Copyright />
        </div>
      )}
    </div>
  );
};

export default memo(Sidebar);
